module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-invoice-controller"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "columns large-5"
  }, [(_vm.client) ? _c('driver', {
    attrs: {
      "type": 'driver-card',
      "item": _vm.client.main_driver
    }
  }) : _vm._e()], 1), _c('div', {
    staticClass: "columns shrink"
  }, [_c('span', [_vm._v("Emission Date")]), (_vm.item.emission_date) ? _c('h4', [_vm._v(_vm._s(_vm.$dateFormat(_vm.item.emission_date, 'DD/MM/YYYY')))]) : _vm._e(), _c('span', [_vm._v("Overdue Date")]), (_vm.item.due_date) ? _c('h4', [_vm._v(_vm._s(_vm.$dateFormat(_vm.item.due_date, 'DD/MM/YYYY')))]) : _vm._e()]), _c('div', {
    staticClass: "columns shrink"
  }, [_c('span', [_vm._v("Status")]), _c('h4', [_vm._v(_vm._s(_vm.item.status))]), (_vm.$isModuleEnabled('aruba-italian-e-invoice')) ? [_c('span', [_vm._v("Xml filename")]), (_vm.item.extra.hasOwnProperty('einvoice')) ? _c('h4', [_vm._v(_vm._s(_vm.item.extra.einvoice.uploadedFileName))]) : _c('h4', [_vm._v("--")])] : _vm._e()], 2), _c('div', {
    staticClass: "column"
  }, [_c('span', [_vm._v("Document type")]), _c('h4', [_vm._v(_vm._s(_vm.item.type))]), _c('span', [_vm._v("Number")]), (_vm.item.type !== 'PROFORMA') ? _c('h4', [_vm._v(_vm._s(_vm.item.internal_id))]) : _c('h4', [_vm._v("--")])])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "inner-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('client', {
    attrs: {
      "item": _vm.client,
      "type": 'billing'
    }
  })], 1), _c('div', {
    staticClass: "columns"
  }, [_c('client', {
    attrs: {
      "item": _vm.client,
      "type": 'contacts'
    }
  })], 1)]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('table', [_vm._m(0), _c('tbody', _vm._l((_vm.item.records), function(item) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(item.id))]), _c('td', [_vm._v(_vm._s(item.driver_id))]), _c('td', [_c('div', [_vm._v(_vm._s(_vm._f("walletableType")(item.walletable_type)))]), _c('div', [_vm._v(_vm._s(item.walletable_id))])]), _c('td', {
      staticStyle: {
        "font-family": "monospace"
      }
    }, _vm._l((item.reason.split('|')), function(reason) {
      return _c('div', [(reason.startsWith('---')) ? _c('hr', {
        staticStyle: {
          "border-style": "dotted",
          "margin": "0.5em"
        }
      }) : (reason.startsWith('- ')) ? _c('strong', [_vm._v(_vm._s(_vm.cleanString(reason, "- ")))]) : (reason.startsWith('>>')) ? _c('span', {
        staticStyle: {
          "display": "block",
          "text-indent": "1em"
        }
      }, [_vm._v(_vm._s(_vm.cleanString(reason, ">>")))]) : _c('span', [_vm._v(_vm._s(reason))])])
    }), 0), _c('td', {
      staticClass: "text-center"
    }, [_c('div', [_vm._v(_vm._s(_vm.currency) + _vm._s(parseFloat(item.amount * item.tax).toFixed(2)))]), _c('div', [_c('small', [_vm._v(_vm._s(-item.tax * 100) + "%")])])]), _c('td', {
      staticClass: "text-center"
    }, [_c('div', [_vm._v(_vm._s(_vm.$priceWithcurrency(_vm.$priceWithVat(-item.amount, -item.tax).toFixed(2))))]), _c('div', [_c('small', [_vm._v(_vm._s(_vm.$priceWithcurrency(-item.amount)) + " VAT EXC")])])])])
  }), 0)])])]), _c('div', {
    staticClass: "row"
  }, [_vm._m(1), _c('div', {
    staticClass: "columns text-right"
  }, [_c('h2', [_vm._v(_vm._s(_vm.$priceWithcurrency(_vm.item.subtotal)))])])]), _c('div', {
    staticClass: "row"
  }, [_vm._m(2), _c('div', {
    staticClass: "columns text-right"
  }, [_c('h2', [_vm._v(_vm._s(_vm.$priceWithcurrency(_vm.item.tax)))])])]), _c('div', {
    staticClass: "row"
  }, [_vm._m(3), _c('div', {
    staticClass: "columns text-right"
  }, [_c('h2', [_vm._v(_vm._s(_vm.currency) + _vm._s(_vm.item.document_total))])])]), (_vm.item.deposits.length) ? _c('div', {
    staticClass: "row"
  }, [_vm._m(4), _c('div', {
    staticClass: "columns text-right"
  }, [_c('h2', [_vm._v("-" + _vm._s(_vm.$priceWithcurrency(_vm.depositsPaid)))])])]) : _vm._e(), _c('div', {
    staticClass: "row"
  }, [_vm._m(5), _c('div', {
    staticClass: "columns text-right"
  }, [_c('h2', [_vm._v(_vm._s(_vm.$priceWithcurrency(_vm.item.total)))])])]), (_vm.item.deposits.length) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('h2', [_vm._v("Deposit details:")]), _vm._l((_vm.item.deposits), function(deposit) {
    return _c('Deposit', {
      attrs: {
        "item": deposit,
        "type": "listing"
      }
    })
  })], 2)]) : _vm._e(), (_vm.$isModuleEnabled('aruba-italian-e-invoice')) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('h2', [_vm._v("Stati fatturazione elettronica")]), (_vm.item.extra.hasOwnProperty('einvoice')) ? _c('div', {
    staticClass: "container"
  }, [_c('base-list', {
    attrs: {
      "component": _vm.component,
      "dataLoader": _vm.xmlStatus,
      "componentType": "einvoice"
    }
  })], 1) : _vm._e()])]) : _vm._e()])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Id")]), _c('th', [_vm._v("Driver Id")]), _c('th', [_vm._v("Type & Id")]), _c('th', [_vm._v("Description (Reason)")]), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Tax")]), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Amount")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns shrink large-offset-9"
  }, [_c('p', [_vm._v("Subtotal")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns shrink large-offset-9"
  }, [_c('p', [_vm._v("Tax total")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns shrink large-offset-9"
  }, [_c('p', [_vm._v("Total")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns shrink large-offset-9"
  }, [_c('p', [_vm._v("Paid deposits")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns shrink large-offset-9"
  }, [_c('p', [_vm._v("Net to pay")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3d16f410!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/backoffice/controllers/Invoice.vue
// module id = 2430
// module chunks = 1